import { analytics } from './analytics'
import { AffiliateEvents } from './events'

/**
 * Which door the account came through. The activation dialog lives in
 * `components/common` (opened from the sidebar for anyone who has not joined)
 * and the landing lives in the section itself, so the two have to stay
 * separable in the funnel.
 */
export type AffiliateJoinSource = 'activation-dialog' | 'landing'

/**
 * Lives here rather than in `pages/affiliate/affiliate.tracking.ts` because
 * the join mutation fires it, and the mutation is shared with a component in
 * `components/common` — which must not reach into a page tree. The two
 * conversion dialogs around it are in `components/common` for the same
 * reason, so their events sit beside it.
 */
export function trackAffiliateProgramJoined(source: AffiliateJoinSource): void {
  analytics.track(AffiliateEvents.PROGRAM_JOINED, { source })
}

/** The denominator of the join rate: the dialog was on screen. */
export function trackAffiliateActivationDialogViewed(): void {
  analytics.track(AffiliateEvents.ACTIVATION_DIALOG_VIEWED)
}

/** Closed with the account still outside the program. */
export function trackAffiliateActivationDialogDismissed(): void {
  analytics.track(AffiliateEvents.ACTIVATION_DIALOG_DISMISSED)
}

export function trackAffiliateWelcomeDialogViewed(): void {
  analytics.track(AffiliateEvents.WELCOME_DIALOG_VIEWED)
}
